import { useBillingContext } from '@shared/scenes/billing/provider';

export function useCanViewCollectionView() {
  const { billing } = useBillingContext();

  return billing.isPaidPlan !== false;
}
